<template>
  <div
    class="flex h-full bg-gray-50 dark:bg-surface-900"
    :class="{ 'overflow-hidden': isOpen }"
  >
    <Sidebar
      ref="sidebarRef"
      v-on-click-outside="shouldCloseSidebar"
      :menu-items
    />
    <div class="flex overflow-x-hidden flex-col flex-1 w-full">
      <CityNavigationMenu
        ref="navigationMenuRef"
        HasToggleableMenu
      />
      <main class="overflow-y-auto h-full bg-gray-100 dark:bg-surface-900">
        <slot name="header" />
        <div class="container max-w-full min-h-screen">
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import Sidebar from "~/components/sidebar.vue";
import { useSidebarStore } from "~/stores/sidebar";
import { vOnClickOutside } from "@vueuse/components";
import CityNavigationMenu from "~/components/CityNavigationMenu.vue";
import Permissions from "~/types/Permissions";
import UserFirstTimeSecurityQuestionsSetup from "~/components/user/FirstTimeSecurityQuestionsSetup.vue";

provide("cityRestricted", true);
provide("readOnly", true);
const sidebarStore = useSidebarStore();
const securityQuestionsStore = useSecurityQuestionsStore();
const dialog = useDialog();
const { checkAndShowSetupIfNeeded } = useSecurityQuestions();
const sidebarRef = ref(null);
const navigationMenuRef = ref(null);
const { isOpen } = storeToRefs(sidebarStore);
const { closeSidebar } = sidebarStore;
const userStore = useUserStore();
await userStore.loadUser();
const menuItems = [
  {
    key: "0",
    label: "Tableau de bord",
    href: "/",
    icon: "dasboard-icon",
    param: "",
  },
  {
    key: "2",
    label: "Documents",
    href: "/city/documents",
    icon: "document-icon",
    param: "",
  },
  {
    key: "3",
    label: "Marchés",
    href: "/city/markets",
    icon: "shopping-icon",
  },
  {
    key: "9",
    label: "Rapports journaliers",
    href: "/city/market-report",
    icon: "document-icon",
    permissions: [Permissions.MarketReportsList],
  },
  {
    key: "4",
    label: "Factures",
    href: "/city/invoices",
    icon: "document-icon",

  },
  {
    key: "5",
    label: "Commerçants",
    href: "/city/merchants",
    icon: "user-group-icon",
    new: true,

  },
  {
    key: "6",
    label: "Signalements",
    href: "/city/events",
    icon: "bell-icon",
  },
  {
    key: "7",
    label: "Statistiques",
    href: "/city/statistics",
    icon: "chart-bar-square",
  },
  {
    key: "8",
    label: "Paramètres",
    href: "/city/settings",
    permissions: [Permissions.SettingsAccess],
    icon: "cog-icon",
  },
];
function shouldCloseSidebar(event) {
  if (
    event.target !== navigationMenuRef.value
    && !navigationMenuRef.value.hamburgerMenuRef.contains(event.target)
  ) {
    closeSidebar();
  }
}

// Security Questions Dialog
function showSecurityQuestionsDialog() {
  dialog.open(UserFirstTimeSecurityQuestionsSetup, {
    props: {
      header: "🔐 Sécurisation de votre compte",
      style: {
        width: "50rem",
      },
      breakpoints: {
        "960px": "75vw",
        "640px": "90vw",
      },
      modal: true,
      dismissableMask: false,
      closable: false,
    },
    onClose: (options) => {
      const data = options?.data;
      if (data?.action === "completed") {
        securityQuestionsStore.completeSetup();
      }
      else if (data?.action === "skipped") {
        securityQuestionsStore.skipSetup();
      }
    },
  });
}

// Watch for security questions setup requirement
watch(
  () => securityQuestionsStore.shouldShowSetup,
  (shouldShow) => {
    if (shouldShow) {
      showSecurityQuestionsDialog();
    }
  },
  { immediate: true },
);

onMounted(async () => {
  // Check and show security questions setup if needed
  await checkAndShowSetupIfNeeded();
});
</script>
